import React, { Fragment, useState, useEffect } from 'react';
import Page from '../../Page';
import { ID_PRIVACY_PAGE } from '../../../css-api';
import { getLocale } from '../../../selectors/router';
import { useSelector } from 'react-redux';
import PrivacyText_de from './privacy_de';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  main: {
    padding: '2em 2em 4em',
    background: '#f1f1f1',
  },
}));

const Privacy = () => {
  const classes = useStyles();
  const [PrivacyText, setPrivacyText] = useState();
  let localeId = useSelector(getLocale);
  useEffect(() => {
    import(`./privacy_${localeId}.js`)
      .then(imp => {
        setPrivacyText(imp.default);
      })
      .catch(() => setPrivacyText(PrivacyText_de));
  });
  return (
    <Fragment>
      <Page
        classNames={classes.main}
        id={ID_PRIVACY_PAGE}
        alignSelf="center"
        localeId={localeId}
      >
        {PrivacyText}
      </Page>
    </Fragment>
  );
};

export default Privacy;
